<action class="button-inline"
        [ngClass]="{'m-r-1 m-l-1': wrapButton()}"
        [status]="status"
        (click)="removeItem()"
        [attr.aria-label]="'Remove from wishlist' | translate">
    <span class="flex flex-middle icon-font-size">
        <i class="icon-trash col-1"
           [style.font-size.px]="19"
           aria-hidden="true"
           #iconHeartLeftRef></i>
    </span>
</action>

<result class="block pos-absolute top-100"
        [status]="status" />
